import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Formik, Form, Field} from 'formik';
import {
  Button,
  Dialog,
  Typography,
  TextField as TextFieldMaterial,
} from '@material-ui/core';
import {TextField} from 'formik-material-ui';
import {Autocomplete} from 'formik-material-ui-lab';
import useUser from 'components/GenericsHooks/useUser';
import Signature from '../../../../components/Editors/Signature';
import Switch from '@material-ui/core/Switch';
import useLoadSectorsForLookup from '../../../sectors/hooks/useLoadLookupSectors';
import {useLoadLookupProfiles} from '../../hooks/index';
import CustomAlert from 'components/grid-dx/alert';
import {i18n2} from 'features/i18n/i18n';
import {ProfileSchema} from 'features/profile/model/Profile';
import {useUtilInformation} from 'components/hooks';

const GridConfig = ({
  open,
  handleClose,
  refresh,
  row,
  remoteChange,
  remoteAdd,
}) => {
  const classes = useStyles();
  const userName = useUser();
  const {token, cwid, role} = useUtilInformation();
  const loadSectors = useLoadSectorsForLookup({token, cwid, role});
  const loadLookupProfiles = useLoadLookupProfiles();
  const [sectors, setSectors] = useState([]);
  const [sectorEdit, setSectorEdit] = useState([]);
  const [perfiles, setPerfiles] = useState([]);
  const [message, setMessage] = useState([]);

  const dataEdit = row ? {...row, sector: sectorEdit} : {};
  const initialValues = {
    ...dataEdit,
    user: userName,
    updatedBy: userName,
    reason: '',
    copyProfile: false,
  };

  useEffect(() => {
    loadSectors.then((response) => {
      const sectorsWithoutDeleted = response.filter((x) => x.deleted === false);
      setSectors(sectorsWithoutDeleted);
      if (row)
        setSectorEdit(response.find((x) => x.iD_Sector === row.iD_Sector));
    });

    loadLookupProfiles.then((response) => {
      setPerfiles(response.filter((x) => x.deleted === false));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  const submit = async (values, formikBag) => {
    if (row) {
      const editingOptions = {
        row: row,
        changed: values,
      };

      remoteChange(editingOptions)
        .then((response) => {
          if (response.ok) {
            setMessage({
              text: 'Editado correctamente',
              open: true,
              successful: true,
            });
            setTimeout(() => {
              handleClose();
              refresh();
            }, 1000);
          } else {
            formikBag.setSubmitting(false);
            response
              .text()
              .then((message) =>
                setMessage({text: message, open: true, successful: false}),
              );
          }
        })
        .catch((err) => {
          return console.log(err);
        });
    } else {
      const addingOptions = {
        added: values,
      };
      remoteAdd(addingOptions)
        .then((response) => {
          if (response.ok) {
            setMessage({
              text: 'Creado correctamente',
              open: true,
              successful: true,
            });
            setTimeout(() => {
              handleClose();
              refresh();
            }, 1000);
          } else {
            formikBag.setSubmitting(false);
            response
              .text()
              .then((message) =>
                setMessage({text: message, open: true, successful: false}),
              );
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const verificarSectorConPerfil = (e, sectorSelect, setFieldValue) => {
    if (!e) return;
    const profileNow = perfiles.find((x) => x.name === e.name);
    if (!profileNow) return;

    const sectorDelPerfilSeleccionado = profileNow.iD_Sector;

    if (
      sectorSelect &&
      sectorSelect.iD_Sector !== sectorDelPerfilSeleccionado
    ) {
      setMessage({
        text: 'El sector seleccionado no coincide con el del perfil a copiar.',
        open: true,
        successful: false,
        warning: true,
      });
    }
    setFieldValue('profileToCopy', profileNow);
  };

  const verificarPerfilConSector = (e, profileSelect, setFieldValue) => {
    if (!e) return;
    const sectorNow = sectors.find((x) => x.name === e.name);
    if (!sectorNow) return;

    const idSectorSeleccionado = sectorNow.iD_Sector;

    if (profileSelect && profileSelect.iD_Sector !== idSectorSeleccionado) {
      setMessage({
        text: 'El sector seleccionado no coincide con el del perfil a copiar.',
        open: true,
        successful: false,
        warning: true,
      });
    }
    setFieldValue('sector', sectorNow);
  };

  return (
    <Dialog maxWidth="md" fullWidth open={open} className={classes.root}>
      <Typography variant="h3" align="center" style={{marginTop: 20}}>
        {i18n2._('Profiles')}
      </Typography>
      <Formik
        enableReinitialize
        initialValues={{...initialValues}}
        onSubmit={submit}
        validationSchema={ProfileSchema}>
        {({isSubmitting, setFieldValue, values, errors, touched}) => (
          <Form style={{padding: 35}} autoComplete="off">
            <div style={{paddingLeft: 20, paddingRight: 20}}>
              <Field
                type="text"
                label={i18n2._('Perfil')}
                name="name"
                variant="outlined"
                autoFocus
                required
                fullWidth
                component={TextField}
                error={errors['name'] && touched['name']}
                helperText={touched['name'] && errors['name']}
                className={classes.field}
              />
              <Field
                type="text"
                name="sector"
                component={Autocomplete}
                options={sectors || null}
                getOptionLabel={(option) => option?.name || ''}
                getOptionSelected={(x, xxx) =>
                  x.iD_Sector === xxx.iD_Sector || ''
                }
                onChange={(e, newvalue) => {
                  verificarPerfilConSector(
                    newvalue,
                    values['profileToCopy'],
                    setFieldValue,
                  );
                }}
                renderInput={(params) => (
                  <TextFieldMaterial
                    {...params}
                    label={i18n2._('Sector')}
                    variant="outlined"
                  />
                )}
              />
              {row === undefined && (
                <>
                  <div style={{paddingBottom: 10, paddingTop: 10}}>
                    <Field
                      component={Switch}
                      name="copyProfile"
                      onChange={(e) =>
                        setFieldValue('copyProfile', e.target.checked)
                      }
                    />
                    <p style={{display: 'inline'}}>
                      {i18n2._('Copiar perfil')}
                    </p>
                  </div>
                  <Field
                    name="profileToCopy"
                    component={Autocomplete}
                    options={perfiles || null}
                    getOptionLabel={(option) => option?.name || ''}
                    getOptionSelected={(x, xxx) =>
                      x.iD_Profile === xxx.iD_Profile || ''
                    }
                    disabled={!values['copyProfile']}
                    onChange={(e, newvalue) => {
                      verificarSectorConPerfil(
                        newvalue,
                        values['sector'],
                        setFieldValue,
                      );
                    }}
                    renderInput={(params) => (
                      <TextFieldMaterial
                        {...params}
                        label={i18n2._('Profiles')}
                        variant="outlined"
                      />
                    )}
                  />
                </>
              )}
            </div>

            <Signature
              user={userName}
              customPadding={null}
              errors={errors}
              touched={touched}
            />
            <div style={{textAlign: 'right', padding: 10}}>
              <Button onClick={() => handleClose()} className="red-text">
                {'Cancelar'}
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {'Confirmar'}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
      <CustomAlert
        message={message.text}
        ms={5000}
        successful={message.successful}
        handleClose={() => setMessage((prev) => ({...prev, open: false}))}
        open={message.open}
        warning={message.warning}
      />
    </Dialog>
  );
};

export default GridConfig;

const useStyles = makeStyles((theme) => ({
  form: {
    width: 700,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  inputsForm: {
    width: '70%',
    margin: 'auto',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(3),
  },
  radio: {
    margin: 'auto',
  },
  FormControlLabel: {
    margin: 0,
    padding: 0,
  },
}));
